module.exports = __webpack_public_path__ + "static/media/img_audience_mobile_x2.43fa50b6.png";